import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FryCommonModule } from '@fry/components/common';
import { MaterialModule } from '@fry/components/material';
import { UnboxedModule } from '@fry/ui';

import { UserHistoryComponent } from '../user-history/user-history.component';


@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    UnboxedModule,
    FryCommonModule,
    RouterModule,
  ],
  declarations: [
    UserHistoryComponent,
  ],
  exports: [
    UserHistoryComponent,
  ]
})
export class UsersCardsModule {}
